/*eslint-disable*/
export default {
    props: {
        isContinentsModal: Boolean,
        isDisabled: Boolean,
        isHovered: Boolean,
        continent: String
    },
    data () {
        return {
            element: null
        };
    },
    mounted () {
        this.element = document.getElementById(this.continent);
    },
    watch: {
        isHovered (val) {
            if (!this.isContinentsModal) {
                return '';
            }
            if (val) {
                this.element.style.filter = 'url(#glow-filter)';
            } else {
                this.element.style.filter = '';
            }
        }
    },
    computed: {
        filter () {
            if (!this.isContinentsModal) {
                return '';
            }
            return this.isDisabled === false ? '' : 'url(#grayscale)';
        }
    }
}